/* global Backbone */
require('backbone-nested')
require('backbone.queryparams')
require('bootstrap')

// Override Backbone.sync to use PUT HTTP method for PATCH requests
// when doing Model#save({...}, { patch: true })
const originalSync = Backbone.sync

Backbone.sync = (method, model, options) => {
  if (method == 'patch') {
    options.type = 'PUT'
  }

  originalSync(method, model, options)
}

export default Backbone
